module.exports = __webpack_public_path__ + "img/26.c2931cd4.jpg";